import { SPLIT_KEY } from '../const';
import { StripeEnv } from './enums';

if (process.env.REACT_APP_GRAPHQL_URI === undefined) {
  throw new Error('REACT_APP_GRAPHQL_URI not set');
}
if (process.env.REACT_APP_VGS_VAULT === undefined) {
  throw new Error('REACT_APP_VGS_VAULT not set');
}
if (process.env.REACT_APP_VGS_ENVIRONMENT === undefined) {
  throw new Error('REACT_APP_VGS_ENVIRONMENT not set');
}
if (process.env.REACT_APP_VGS_CNAME === undefined) {
  throw new Error('REACT_APP_VGS_CNAME not set');
}
if (
  !process.env.REACT_APP_SPLIT_CLIENT_SIDE_API_KEY &&
  !process.env.REACT_APP_SPLIT_IO_KEY
) {
  throw new Error(
    'REACT_APP_SPLIT_CLIENT_SIDE_API_KEY or REACT_APP_SPLIT_IO_KEY not set',
  );
}

const DEFAULT_COLLECT_VERSION = '2.14.0';
const DEFAULT_SHOW_VERSION = '2.0.0';

let environment = 'local';
if (process.env.REACT_APP_ENVIRONMENT?.toLowerCase().includes('prod')) {
  environment = 'prod';
} else if (process.env.REACT_APP_ENVIRONMENT) {
  environment = process.env.REACT_APP_ENVIRONMENT.toLowerCase();
}

export default {
  snap: { graphUri: process.env.REACT_APP_GRAPHQL_URI },
  stripe: (
    stripeEnv: StripeEnv,
  ): {
    publishableApiKey: string | undefined;
  } => {
    const stripeKeyMapper = {
      RAISE: process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY,
      SPONSOR: process.env.REACT_APP_STRIPE_PUBLISHABLE_SPONSOR_API_KEY,
    };
    const getApiKey = (stripeEnv: StripeEnv): string | undefined =>
      stripeKeyMapper[stripeEnv] || process.env.STRIPE_API_KEY;
    return {
      publishableApiKey: getApiKey(stripeEnv),
    };
  },
  vgs: {
    vault: process.env.REACT_APP_VGS_VAULT,
    environment: process.env.REACT_APP_VGS_ENVIRONMENT as VGSEnvironment,
    cname: process.env.REACT_APP_VGS_CNAME,
    uri: `https://${process.env.REACT_APP_VGS_CNAME}`,
    collectVersion:
      process.env.REACT_APP_VGS_COLLECT_VERSION || DEFAULT_COLLECT_VERSION,
    showVersion: process.env.REACT_APP_VGS_SHOW_VERSION || DEFAULT_SHOW_VERSION,
  },
  logger: {
    enabled:
      environment !== 'prod' ||
      process.env.REACT_APP_LOGGING_ENABLED?.toLowerCase() === 'true',
  },
  environment,
  split: {
    authorizationKey:
      process.env.REACT_APP_SPLIT_CLIENT_SIDE_API_KEY ||
      // truthiness has been checked above. At least one of these values is not false.
      process.env.REACT_APP_SPLIT_IO_KEY!,
    key: SPLIT_KEY,
  },
};
